<template>
  <!-- 组件主盒子 -->
  <div>
    <div class="query-select">
      <el-form ref="queryForm" :model="queryForm" :inline="true">
        <el-form-item label="题干">
          <el-input
            v-model.trim="queryForm.questionStem"
            placeholder="请输入题干"
          ></el-input>
        </el-form-item>
        <el-form-item label="题型">
          <el-select
            v-model="queryForm.questionType"
            placeholder="请搜索题型"
            @change="getTableInfo"
            clearable
          >
            <el-option
              v-for="item in theoryQuestionTypes"
              :key="item.value"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" class="mr-left">
          <el-date-picker
            v-model="dateRange"
            @change="getTableInfo"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="请搜索创建日期"
            end-placeholder="请搜索创建日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          plain
          round
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="warning"
          icon="el-icon-refresh-left"
          @click="reset"
          >重置</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-plus"
          @click="openForm('create')"
          >新增</el-button
        >
        <el-button
          plain
          round
          size="small"
          type="success"
          icon="el-icon-upload2"
          @click="onUpload"
          >导入</el-button
        >
      </div>
    </div>
    <!-- 分割 -->
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        stripe
        size="small"
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionStem"
          label="题干"
          width="500"
          show-overflow-tooltip
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="questionType"
          label="题型"
          min-width="120"
        >
          <template slot-scope="scope">
            <dict-tag type="theory_type" :value="scope.row.questionType" />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="questionAnswer"
          label="答案"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>
        <el-table-column align="center" label="操作" width="300">
          <template slot-scope="scope">
            <el-button
              plain
              round
              size="small"
              type="primary"
              @click="openDetail(scope.row.questionsId)"
              >查看</el-button
            >
            <el-button
              plain
              round
              size="small"
              type="warning"
              @click="openForm('edit', scope.row.questionsId)"
              >编辑</el-button
            >

            <el-button
              plain
              round
              size="small"
              type="danger"
              @click="removeClick(scope.row.questionsId)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="10"
        layout="total, prev, pager, next"
        :current-page.async="queryForm.pageNum"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <TheoryBankDetail ref="detailRef"></TheoryBankDetail>
    <TheoryBankForm ref="formRef" @success="getTableInfo"></TheoryBankForm>
    <TheoryBankUpload
      ref="uploadRef"
      @success="getTableInfo"
    ></TheoryBankUpload>
  </div>
</template>
<script>
import {
  getQuestionBankTable,
  removeQuestion
} from "@/api/questionBank/theory";
import TheoryBankUpload from "./TheoryBankUpload.vue";
import TheoryBankForm from "./TheoryBankForm.vue";
import TheoryBankDetail from "./TheoryBankDetail.vue";
import { getDictOptions } from "@/utils/dict.js";
export default {
  name: "TheoryBank",
  components: {
    TheoryBankUpload,
    TheoryBankForm,
    TheoryBankDetail
  },
  data() {
    return {
      loading: false,
      queryForm: {
        pageNum: 1,
        pageSize: 10,
        questionType: "",
        questionStem: ""
      },
      dateRange: null,
      totalCount: 0,
      tableData: null
    };
  },

  // 创建完毕状态(里面是操作)
  created() {},
  // 挂载结束状态(里面是操作)
  mounted() {
    this.loading = true;
    this.getTableInfo();
  },
  // 里面的函数只有调用才会执行
  methods: {
    openForm(type, id) {
      this.$refs.formRef.open(type, id, this.$route.query.id);
    },
    onUpload() {
      this.$refs.uploadRef.open();
    },
    selectQuestionType() {
      this.getTableInfo();
    },
    async openDetail(id) {
      this.$refs.detailRef.open(id);
    },
    async removeClick(id) {
      this.$confirm("此操作将删除该题目,是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await removeQuestion(id);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getTableInfo();
        })
        .catch(() => {});
    },

    async getTableInfo() {
      let obj;
      if (this.dateRange != null) {
        obj = {
          params: { beginTime: this.dateRange[0], endTime: this.dateRange[1] }
        };
      }
      const res = await getQuestionBankTable({
        ...this.queryForm,
        ...obj,
        questionBankId: this.$route.query.id
      });
      this.loading = false;

      this.tableData = res.data.rows;
      this.totalCount = res.data.total;
      // }
    },

    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },

    reset() {
      this.queryForm.pageNum = 1;
      this.dateRange = null;
      this.queryForm.questionType = "";
      this.queryForm.questionStem = "";
      this.getTableInfo();
    }
  },
  computed: {
    theoryQuestionTypes() {
      return getDictOptions("theory_type");
    },
    styles() {
      let style = {};
      if (this.minHeight) {
        style.minHeight = `${this.minHeight}px`;
      }
      if (this.height) {
        style.height = `${this.height}px`;
      }
      return style;
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
&::-webkit-scrollbar {
  width: 3px;
  height: 5px;
}

// 滚动条里面默认的小方块,自定义样式
&::-webkit-scrollbar-thumb {
  background: #8798af;
  border-radius: 2px;
}

// 滚动条里面的轨道
&::-webkit-scrollbar-track {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/QuestionBank/theory/index.vue